<template>
    <v-list-item class="pa-0">
        <v-list-item-icon v-if="userToShow && userToShow.pictureProfileUrl">
            <v-img
                :src="baseUrl + '/' + userToShow.pictureProfileUrl"
                class="rounded-circle"
                width="32"
                height="32"
            ></v-img>
        </v-list-item-icon>
        <v-list-item-icon v-else-if="userToShow">
            <v-avatar size="32" color="primary">
                <span class="white--text text-caption">
                    {{ getUserInitials(userToShow.fullName) }}
                </span>
            </v-avatar>
        </v-list-item-icon>

        <v-list-item-content>
            <v-list-item-title v-if="userToShow && userToShow.fullName">
                {{ userToShow.fullName }}
            </v-list-item-title>
            <v-list-item-title v-else>
                {{ dateToShow | formatDate }}
            </v-list-item-title>

            <v-list-item-subtitle v-if="userToShow && userToShow.fullName">
                {{ dateToShow | formatDate }}
            </v-list-item-subtitle>
        </v-list-item-content>
    </v-list-item>
</template>

<script>
import config from "@/../public/static/config.json";
export default {
    name: "UserInfo",
    props: {
        // The item object containing user and date information
        item: {
            type: Object,
            required: true,
        },
    },

    computed: {
        // Priority: updatedUser > createdUser > null
        userToShow() {
            // First priority: updatedUser (if exists and not null)
            if (this.item.updatedUser) {
                return this.item.updatedUser;
            }

            // Second priority: createdUser (if exists and not null)
            if (this.item.createdUser) {
                return this.item.createdUser;
            }

            // No user found
            return null;
        },
        baseUrl() {
            return process.env.NODE_ENV === "production"
                ? config.APP_URL_PROD
                : config.APP_URL_DEV;
        },
        // Priority: updatedAt > createdAt
        dateToShow() {
            // First priority: updatedAt (if exists)
            if (this.item.updatedAt) {
                return this.item.updatedAt;
            }

            // Second priority: createdAt (fallback)
            return this.item.createdAt;
        },
    },

    methods: {
        // Get user initials for avatar when no profile picture
        getUserInitials(fullName) {
            if (!fullName) return "??";

            const names = fullName.trim().split(" ");
            if (names.length === 1) {
                return names[0].substring(0, 2).toUpperCase();
            }

            return (
                names[0].charAt(0) + names[names.length - 1].charAt(0)
            ).toUpperCase();
        },
    },
};
</script>

<style scoped>
.v-list-item {
    min-height: auto;
}
</style>
